<template>
  <div id="group-buy" >
    <img src="@/assets/ad-server/1.png">
    <div class="from-wrapper" >
      <div class="from" >
        <div class="number" >
          <van-field v-model="number" placeholder="请填写定制数量，如：30套" />
        </div>
        <div class="info" >
          <van-field v-model="contact" placeholder="请填写联系人" />
          <van-field v-model="phone" placeholder="请填写联系电话" />
        </div>
        <div class="form-reservation" >
          <div class="order" >
            <div>已有预约</div>
            <div>{{ orderCount }} <span>单</span> </div>
          </div>
          <div class="btn" @click="dialog" ref="reservation" >我要预约</div>
        </div>
      </div>
    </div>
    <img src="@/assets/ad-server/2.png">
    <img src="@/assets/ad-server/3.png">
    <div style="width: 100%; height: 55px" ></div>
    <div class="reservation" :class="{ 'reservationBottom': isShowBtn }" @click="routerPath" >
      立即预约
    </div>
    <div class="customer-service">
      <img src="@/assets/ad-server/icon1.png">
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Field, Dialog } from 'vant'
import { getUserInfo, getToken } from '@/libs/cookie-storage'
import { createMatchServiceReservationOrder, getMatchServiceReservationOrderPageInfo } from '@/api/match'
import { ImageFormat, getSourceType } from '@/utils/index'
Vue.use(Field).use(Dialog)
export default {
  name: 'groupBuy',
  data() {
    return {
      number: null,
      contact: null,
      phone: null,
      orderCount: 0,
      isShowBtn: false,
      shareParams: {
        title: '斑马邦运动装备定制团购',
        abstract: '多种款式，个性定制，赛事品质运动装备尽在斑马邦体育',
        link: window.location.href,
        image: this.filterImage()
      }
    }
  },
  mounted() {
    if (getUserInfo()) {
      this.phone = getUserInfo().mobile
      this.contact = getUserInfo().nickName
    }
    let share = {
      title: '斑马邦运动装备定制团购',
      link: window.location.href + '?v',
      image: this.filterImage(),
      abstract: '多种款式，个性定制，赛事品质运动装备尽在斑马邦体育'
    }
    this.wxShare(share)
    /*
    if (AppType.isInApp()) {
      hideTitleBar(1)
    }
    */
    window.addEventListener('scroll', this.handleScroll)
    this.getMatchServiceReservationOrderPageInfo()
    this.trackingTD('page_bmb_jersey')
  },
  methods: {
    getMatchServiceReservationOrderPageInfo() {
      let params = {
        passport: getToken(),
        serviceType: 4
      }
      getMatchServiceReservationOrderPageInfo(params).then(response => {
        if (response) {
          if (response.data && response.data.orderCount) {
            this.orderCount = response.data.orderCount
          }
        }
      })
    },
    dialog() {
      if (this.number && this.contact && this.phone) {
        this.formValidator = true
      } else {
        this.formValidator = false
      }
      let content = {}
      if (this.formValidator) {
        content.title = '提交成功'
        content.message = '工作人员会在12小时内与您取得联系'
      } else {
        content.title = '提交失败'
        content.message = '请填写预约信息以便工作人员快速取得您的联系'
        Dialog.alert({
          title: content.title,
          message: content.message
        }).then(() => {
        })
        return
      }
      let params = {
        serviceType: 4,
        userCount: this.number,
        city: this.area,
        userName: this.contact,
        phone: this.phone,
        matchName: this.name
      }
      params.sourceId = getSourceType()
      createMatchServiceReservationOrder(params).then(response => {
        if (response) {
          this.orderCount += 1
          Dialog.alert({
            title: content.title,
            message: content.message
          }).then(() => {
          })
        }
      })
    },
    routerPath() {
      document.body.scrollTop = 60
      document.documentElement.scrollTop = 60
    },
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let offsetTop = this.$refs.reservation.offsetTop
      offsetTop += this.$refs.reservation.offsetParent.offsetTop
      offsetTop += this.$refs.reservation.offsetHeight
      scrollTop > offsetTop ? this.isShowBtn = true : this.isShowBtn = false
    },
    filterImage() {
      return ImageFormat.imageView('FgmEz7ZSyofFkvxm55-KhzJOpOhf', 120, 120)
    }
  }
}
</script>

<style lang="stylus">
input:-ms-input-placeholder {
  color: #C4C4C4;
}/* Internet Explorer 10+ */

input::-webkit-input-placeholder {
  color: #C4C4C4;
}/* WebKit browsers */

input::-moz-placeholder {
  color: #C4C4C4;
}/* Mozilla Firefox 4 to 18 */

input:-moz-placeholder {
  color: #C4C4C4;
}/* Mozilla Firefox 19+ */
#group-buy
  img
    width 100%
    vertical-align top
  .from-wrapper
    background-color #FB5754
    padding: 15px
    .from
      min-height 80px
      background-color: white;
      border-radius:8px;
      overflow hidden
      padding: 15px
      .number
        .van-cell
          border-radius:6px;
          border:1px solid rgba(138,138,138,1);
          text-align center !important
          font-size:14px;
          font-weight:400;
          color:rgba(196,196,196,1);
          .van-cell__value
            text-align center
          .van-cell__value--alone
            text-align center !important
            .van-field__body
              text-align center
              .van-field__control
                text-align center
      .info
        display flex
        margin-top 10px
        justify-content: space-between;
        .van-cell
          width calc(50% - 5px)
          border-radius:6px;
          border:1px solid rgba(138,138,138,1);
          text-align center !important
          font-size:14px;
          font-weight:400;
          color:rgba(196,196,196,1);
          .van-cell__value
            text-align center
          .van-cell__value--alone
            text-align center !important
            .van-field__body
              text-align center
              .van-field__control
                text-align center
      .form-reservation {
        display: flex;
        margin-top 25px;
        align-items: center;
        justify-content: space-between;
        .order {
          width: 60%;
          position: relative;
          div:first-child {
            font-size:14px;
            font-weight:400;
            color: black;
            padding-bottom: 5px;
          }
          div:last-child {
            font-size:20px;
            font-weight:400;
            color: #FB5754;
            span {
              font-size: 14px;
              padding-left: 10px;
            }
          }
          ::before{
            content: '';
            position: absolute;
            width: 1px;
            height: 35px;
            background-color: #FB5754;
            right: 0;
            top: 50%;
            transform: translate(0, -50%);
          }
        }
        .btn {
          width:112px;
          height:42px;
          line-height: 42px;
          background: #FB5754;
          border-radius:21px;
          font-size:16px;
          font-weight:400;
          color:rgba(255,255,255,1);
          text-align: center;
        }
      }
  .reservation {
    width: 100%;
    height:55px;
    line-height: 55px;
    background: #FB5754;
    font-size:18px;
    font-weight:400;
    color:rgba(255,255,255,1);
    text-align: center;
    position: fixed;
    bottom: -55px;
    left: 0;
    transition: bottom 0.3s ease;
  }
  .reservationBottom {
    bottom: 0;
  }

  .customer-service {
    width:57px;
    height:57px;
    position fixed
    bottom: 70px
    right: 15px
    img {
      width 100%
      height 100%
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/ad-server/group-buy.vue